import { Fragment } from 'react'
import { Modal } from '@vzmi/shp_shared_compo'
import _ from 'lodash'
import {
  checkIsFakeProductId,
  getAttrMap
} from '../../helpers'
import styles from './styles.css'

const ProductModal = props => {
  const {
    isTwoLayerAttr,
    products,
    children,
    ...restProps
  } = props
  const attrMap = getAttrMap(isTwoLayerAttr)
  return (
    <Modal
      cancelText='取消'
      {...restProps}
    >
      <br />
      <div className={styles.productsInfo}>
        {_.map(products, product => {
          const productId = _.get(product, attrMap.productId)
          const productName = _.get(product, attrMap.productName)
          const isFakeId = checkIsFakeProductId(productId)
          return (
            <Fragment key={productId}>
              {!isFakeId && (
                <p className={styles.tip}>{productId}</p>
              )}
              <p className={styles.row}>{productName}</p>
            </Fragment>
          )
        })}
      </div>
      <br />
      {children}
    </Modal>
  )
}

export default ProductModal
